export class AppRoutesI18n {
    public static readonly AvailableFundsSummary = 'Available Funds Summary';
    public static readonly ContactUs = 'Contact Us';
    public static readonly Dashboard = 'Dashboard';
    public static readonly IncreaseCreditLimit = 'Increase Credit Limit';
    public static readonly InvoiceUploadHistory = 'Upload History';
    public static readonly RequestFunds = 'Request Funds';
    public static readonly MobileUploads = 'Mobile Uploads';
    public static readonly MobileUploadToken = 'Mobile Upload Token';
    public static readonly Login = 'Login';
    public static readonly Logout = 'Logout';
    public static readonly ResetPassword = 'Reset Password';
    public static readonly NotFound = 'Not Found';
    public static readonly LocalClaims = 'Local Claims';
    public static readonly LocalUserState = 'Local User State';
    public static readonly Health = 'Health';
    public static readonly SelectCompany = 'Switch Account';
    public static readonly BrowserNotSupported = 'Browser Not Supported';
    public static readonly Eula = 'End-User License Agreement';
}
